module.exports = __webpack_public_path__ + "static/media/productos_ingredientes_pasta_cacahuate.abd9a1a0.png";